<template>
    <div class="withdrawal-record">
        <div :class="{'none-data-list':!listData.total}">
            <div class="hd">
                <el-button type="primary" plain size="small" @click="openWithdrawalDialog()">去提现</el-button>
                <div>
                    时间筛选：
                    <el-date-picker
                        v-model="date"
                        size="small"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="datePickerChange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                </div>
            </div>
            <div class="list-wrap">
                <el-table :data="listData.list" style="width: 100%">
                    <el-table-column prop="index" label="序" width="60px">
                        <template slot-scope="scope">
                            <span :title="scope.row.index">
                            {{ scope.row.index }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="accountname" label="提现账户">
                        <template slot-scope="scope">
                            <span :title="scope.row.accountname">
                            {{ scope.row.accountname }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="applydate" label="提现时间">
                        <template slot-scope="scope">
                            <span :title="scope.row.applydate">
                            {{ scope.row.applydate }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="applyprice" label="提现金额 (元)" width="140px">
                        <template slot-scope="scope">
                            <span :title="scope.row.applyprice">
                            {{ scope.row.applyprice }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="auditstatus" label="提现状态" width="120px">
                        <template slot-scope="scope">
                            <!-- <label class="state state1" v-if="scope.row.auditstatus == 1">待提交</label> -->
                            <label class="state state2" v-if="scope.row.auditstatus == 2">审核中</label>
                            <label class="state state3" v-else-if="scope.row.auditstatus == 3">审核通过</label>
                            <label class="state state4" v-else>审核不通过</label>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="110px">
                        <template slot-scope="scope">
                            <a
                                href="javascript:"
                                class="edit"
                                v-if="scope.row.state == 1"
                                @click="openWithdrawalDialog(scope.row.applyguid)"
                            >编辑</a
                            >
                            <a
                                href="javascript:"
                                class="preview"
                                v-else
                                @click="openWithdrawalDialog(scope.row.applyguid, true)"
                            >查看</a
                            >
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="listParams.pageindex + 1"
                    :page-sizes="[5, 10, 20, 50]"
                    :page-size="listParams.pagesize"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="listData.total"
                >
                </el-pagination>
            </div>
        </div>
        <div class="none-data" v-show="!listData.total && listData.isLoad">
            暂无数据
            <el-button type="primary" plain size="small" @click="openWithdrawalDialog()">去提现</el-button>
        </div>

        <el-dialog
            title="余额提现"
            :visible.sync="withdrawalDialog.show"
            width="800px"
            custom-class="withdrawal-dialog"
            @close="closeWithdrawalDialog"
            append-to-body
            :close-on-press-escape="false"
            :close-on-click-modal="false"
        >
            <withdrawal-dialog
                @closeWithdrawalDialog="closeWithdrawalDialog"
                v-if="withdrawalDialog.show"
                :guid="withdrawalDialog.guid"
                :is-detail="withdrawalDialog.isDetail"
            ></withdrawal-dialog>
        </el-dialog>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import WithdrawalDialog from './withdrawal-dialog.vue';
import fa from "element-ui/src/locale/lang/fa";

export default {
    name: 'WithdrawalRecord',
    components: {
        WithdrawalDialog
    },
    data() {
        return {
            date: [],
            listParams: {
                pageindex: 0,
                pagesize: 10,
                startdate: '',
                enddate: ''
            },
            listData: {
                list: [],
                total: 0,
                isLoad: false
            },
            withdrawalDialog: {
                show: false,
                guid: '',
                isDetail: false
            }
        };
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    mounted() {
        this.getList();
    },
    methods: {
        ...mapActions(['getUserInfo']),
        datePickerChange() {
            this.listParams.startdate = this.date && this.date.length ? this.date[0] : '';
            this.listParams.enddate = this.date && this.date.length ? this.date[1] : '';
            this.refreshList();
        },
        refreshList() {
            this.listParams.pageindex = 0;
            this.getList();
        },
        getList() {
            let params = {
                userguid: this.userInfo.userguid,
                ...this.listParams
            };
            this.$Api.getWithdrawalRecordList(params).then((data) => {
                this.listData.list = data.applylist.map((item, index) => {
                    item.index = this.listParams.pageindex * this.listParams.pagesize + index + 1;
                    return item;
                });
                this.listData.total = data.pageinfo.totalnumcount;
                this.listData.isLoad = true;
            });
        },
        handleSizeChange(e) {
            this.listParams.pagesize = e;
            this.getList();
        },
        handleCurrentChange(e) {
            this.listParams.pageindex = e - 1;
            this.getList();
        },
        openWithdrawalDialog(guid = '', isDetail = false) {
            this.withdrawalDialog.guid = guid;
            this.withdrawalDialog.isDetail = isDetail;
            this.withdrawalDialog.show = true;
        },
        closeWithdrawalDialog() {
            this.withdrawalDialog.show = false;
            this.withdrawalDialog.guid = '';
            this.withdrawalDialog.isDetail = false;
            this.getUserInfo();
            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
@import './style/withdrawal-record.scss';
</style>
